import LoadingView from '@/views/SSOLoading';
import { CONFIG_SSO_SERVER_ENDPOINT } from '@/config'

export default [
  {
    path: CONFIG_SSO_SERVER_ENDPOINT,
    name: 'sso',
    component: LoadingView
  }
];
